module.exports = __webpack_public_path__ + "static/media/bill_red.8ff9c9ea.svg";